"use strict";

exports.__esModule = true;
exports.toPromise = toPromise;
var _rxjs = require("rxjs");
function toPromise(a) {
  if ((0, _rxjs.isObservable)(a)) return (0, _rxjs.firstValueFrom)(a);
  return a;
}